module.exports = __webpack_public_path__ + "img/index-book.adc3d865.png";